var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"form-check form-switch"},[_c('input',{staticClass:"form-check-input",attrs:{"type":"checkbox"},domProps:{"checked":_vm.published},on:{"click":_vm.toggle}}),_vm._v(" "),_c('label',{staticClass:"form-check-label",on:{"click":_vm.toggle}})])])
}
var staticRenderFns = []

export { render, staticRenderFns }